import { FC } from 'react'
import Link from 'next/link'
import clsx from 'clsx'

import { useRouter } from 'next/router'

import { ISearchPagination, IStartedPagination, IMiddlePagination, IEndedPagination } from './data'

import styles from './search-pagination.module.scss'

const FRONTIER_CHANGE = 7
const PAGE_OFFSET = 3

const replacePage = (link: string, newPage: number) => {
  if (newPage === 1) {
    const newLink = link.replace(/(\?|&)page=\d+(&|$)/, '$1')
    return newLink.endsWith('?') ? newLink.slice(0, -1) : newLink
  } else if (link.includes('page')) return link.replace(/page=\d+/, `page=${newPage}`)
  else if (link.includes('?')) return `${link}&page=${newPage}`
  else return `${link}?page=${newPage}`
}

const StartedPagination = ({
  maxPage,
  currentPage,
  link,
  changePageHandle,
}: IStartedPagination) => {
  const lengthPage = maxPage > FRONTIER_CHANGE ? FRONTIER_CHANGE : maxPage
  const ArrayForRender = Array(lengthPage).fill(0)

  return (
    <div>
      {ArrayForRender.map((_, index) => {
        const formatedLink = replacePage(link, index + 1)

        return (
          <Link
            className={clsx(styles.bulletPage, {
              [styles.active]: currentPage === index + 1,
            })}
            key={index}
            href={formatedLink}
            onClick={() => changePageHandle(index + 1)}
          >
            <span>{index + 1}</span>
          </Link>
        )
      })}
    </div>
  )
}

const MiddlePagination = ({ currentPage, link, changePageHandle }: IMiddlePagination) => {
  const leftPages = Array(PAGE_OFFSET).fill(0)
  const RightPages = Array(PAGE_OFFSET).fill(0)
  const linkCurrentPage = replacePage(link, currentPage)

  return (
    <div>
      {leftPages.map((_, index) => {
        const formatedLink = replacePage(link, currentPage - PAGE_OFFSET + index)

        return (
          <Link
            href={formatedLink}
            key={index}
            className={styles.bulletPage}
            onClick={() => changePageHandle(currentPage - PAGE_OFFSET + index)}
          >
            <span>{currentPage - PAGE_OFFSET + index}</span>{' '}
          </Link>
        )
      })}

      <Link
        className={clsx(styles.bulletPage, styles.active)}
        href={linkCurrentPage}
        onClick={() => changePageHandle(currentPage)}
      >
        <span>{currentPage}</span>{' '}
      </Link>

      {RightPages.map((_, index) => {
        const formatedLink = replacePage(link, currentPage + 1 + index)

        return (
          <Link
            key={index}
            href={formatedLink}
            onClick={() => changePageHandle(currentPage + 1 + index)}
            className={styles.bulletPage}
          >
            <span>{currentPage + index + 1}</span>
          </Link>
        )
      })}
    </div>
  )
}

const EndedPagination = ({ maxPage, currentPage, link, changePageHandle }: IEndedPagination) => {
  const ArrayForRender = Array(FRONTIER_CHANGE).fill(0)
  return (
    <div>
      {ArrayForRender.map((_, index) => {
        const formatedLink = replacePage(link, maxPage + 1 - FRONTIER_CHANGE + index)
        return (
          <Link
            href={formatedLink}
            className={clsx(styles.bulletPage, {
              [styles.active]: currentPage === maxPage - FRONTIER_CHANGE + index + 1,
            })}
            onClick={() => changePageHandle(maxPage + 1 - FRONTIER_CHANGE + index)}
            key={index}
          >
            <span>{maxPage - FRONTIER_CHANGE + index + 1}</span>{' '}
          </Link>
        )
      })}
    </div>
  )
}

const FinalPagination = ({ maxPage, currentPage, link, handleParameterSet }: ISearchPagination) => {
  const changePageHandle = (page: number) => {
    handleParameterSet('page', String(page))
  }
  if ((maxPage === 0 && currentPage === 0) || maxPage < currentPage) return null

  if (currentPage < FRONTIER_CHANGE) {
    return (
      <StartedPagination
        maxPage={maxPage}
        currentPage={currentPage}
        link={link || ''}
        changePageHandle={changePageHandle}
      />
    )
  }
  if (currentPage > maxPage - FRONTIER_CHANGE + 1) {
    return (
      <EndedPagination
        maxPage={maxPage}
        currentPage={currentPage}
        changePageHandle={changePageHandle}
        link={link || ''}
      />
    )
  }

  return (
    <MiddlePagination
      currentPage={currentPage}
      changePageHandle={changePageHandle}
      link={link || ''}
    />
  )
}

const SearchPagination: FC<ISearchPagination> = ({
  maxPage,
  currentPage,
  handleParameterSet,
}: ISearchPagination) => {
  const router = useRouter()

  if (maxPage <= 1) return null

  return (
    <div className={styles.pagination}>
      <FinalPagination
        maxPage={maxPage}
        currentPage={currentPage}
        link={router.asPath}
        handleParameterSet={handleParameterSet}
      />
    </div>
  )
}

export default SearchPagination
